export default __webpack_public_path__ + "static/media/guilherme.fab500ca.webp";